import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

const PatientList = ({ setPatient, setCurrentStep }) => {
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [patients, setPatients] = useState([]);

  useEffect(() => {
    patientDetail();
  }, []);
  function patientDetail() {
    const savedPatientDetails = localStorage.getItem("patientDetails");
    if (savedPatientDetails) {
      try {
        const parsedPatients = JSON.parse(savedPatientDetails);
        // console.log(parsedPatients, "parsedPatients");
        
        if (Array.isArray(parsedPatients)) {
          setPatients(parsedPatients.filter(item=>(!item.healthIdNumber || item.is_scanned===1)));
        } else {
          setPatients([]);
        }
      } catch (error) {
        console.error("Error parsing patient details:", error);
        setPatients([]);
      }
    } else {
      setPatients([]);
    }
  }

  const handlePatientClick = (index) => {
    setSelectedIndex(index);
    const patient = patients[index];

    localStorage.setItem("selectedIndex", JSON.stringify(patient));

    const data = localStorage.getItem("selectedIndex");

    if (data) {
      try {
        const parsedData = JSON.parse(data);
        setPatient(parsedData);
        setCurrentStep("ConfirmPatientDetail");
      } catch (error) {
        console.error("Error parsing stored patient data:", error);
      }
    }
  };

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA  and store all your medical records in one
                  place. Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            <div className="col-md-6">
              <div className="form-card content">
                <h3>Select Your Pathkind Lab Profile</h3>
                <p className="pt-3">
                  Select profile to Create/Link your ABHA 
                </p>
                <form className="pt-3">
                  <div className="col-ms-10 col-lg-10 col-xl-10 col-sm-10 col-xs-10">
                    <div className="row">
                      <div className="patient-profile">
                        {patients?.length > 0 ? (
                          patients.map((patient, index) => (
                            <div key={index}>
                              
                                  
                                  <div
                                    key={index}
                                    className={`col-12 d-flex align-items-center bg-white p-3 mb-2 rounded ${
                                      selectedIndex === index
                                        ? "border border-primary"
                                        : ""
                                    }`}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => handlePatientClick(index)}
                                  >
                                    <div
                                      className="avatar-initial me-3 d-flex align-items-center justify-content-center text-white fw-bold"
                                      style={{
                                        width: "50px",
                                        height: "50px",
                                        borderRadius: "50%",
                                        backgroundColor: "#007bff",
                                        fontSize: "20px",
                                        textTransform: "uppercase"
                                      }}
                                    >
                                      {patient.fname?.charAt(0)|| patient.fullname?.charAt(0)}
                                    </div>
                                    <div>
                                      <h5 className="mb-1 patient-name">
                                         {patient.fname? patient.fname+" "+patient.lname: patient.fullname}
                                      </h5>
                                      <div className="d-flex flex-wrap gap-2 patient-self">
                                        <span>Self |</span>
                                        <span>{patient.gender} |</span>
                                        <span>
                                          {patient.dob}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                
                            </div>
                          ))
                        ) : (
                          <div className="text-left d-flex flex-column ">
                            <p>
                              No patient profiles available or all patients have
                              linked their ABHA with us.
                            </p>
                            <button
                              onClick={() => {
                                window.location.reload();
                              }}
                              className="continue-btn-back"
                            >
                              Try Different Account
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default PatientList;
